// extracted by mini-css-extract-plugin
export var container = "InfoTabs-module--container--2zujF";
export var tabs = "InfoTabs-module--tabs--3kuVE";
export var accordion = "InfoTabs-module--accordion--1iD5_";
export var content = "InfoTabs-module--content--e4LIr";
export var extraButton = "InfoTabs-module--extraButton--1qM-H";
export var rotated = "InfoTabs-module--rotated--JTYxs";
export var cardContainer = "InfoTabs-module--cardContainer--3kMNU";
export var table = "InfoTabs-module--table--3ixv7";